import { render, staticRenderFns } from "./UpdateGroups.vue?vue&type=template&id=6f76bc7a&scoped=true&"
import script from "./UpdateGroups.vue?vue&type=script&lang=ts&"
export * from "./UpdateGroups.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateGroups.vue?vue&type=style&index=0&id=6f76bc7a&scoped=true&lang=scss&"
import style1 from "./UpdateGroups.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f76bc7a",
  null
  
)

export default component.exports